import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import getBaseUrl from "lib/utils/getBaseUrl";
import { useIntl } from "react-intl";

interface AmericanIssuerSeoProps {
  title?: string;
}
export default function AmericanIssuerSeo({ title }: AmericanIssuerSeoProps) {
  const intl = useIntl();
  const issuer = useAmericanIssuer();

  const pageTitle = title
    ? `${issuer.primaryTickerSymbol} - ${issuer.name} | ${title} | Fundamentei`
    : `${issuer.primaryTickerSymbol} - ${issuer.name} | Fundamentei`;
  const description = intl.formatMessage(
    {
      defaultMessage:
        "{primaryTickerSymbol} - {name}: Análise Fundamentalista, Cotação, Balanços atualizados e histórico, Dividendos (DY), Indicadores (P/L, P/VPA) e muito mais!",
      id: "DMTyFD",
    },
    {
      primaryTickerSymbol: issuer.primaryTickerSymbol,
      name: issuer.name,
    },
  );
  const gitShaShort = process.env.GIT_SHA_SHORT || "1";
  const languageCode = intl.locale === "pt-BR" ? "pt-BR" : "en-US";
  const imageUrl = `${getBaseUrl()}/og/issuer/${issuer.primaryTickerSymbol.toLowerCase()}?locale=${languageCode}&ns=us&v=${gitShaShort}`;

  return (
    <FundamenteiMetadata
      title={pageTitle}
      description={description}
      openGraph={{
        images: [
          {
            url: imageUrl,
            width: 1200,
            height: 630,
            alt: `${issuer.primaryTickerSymbol} - ${issuer.name}`,
          },
        ],
      }}
    />
  );
}
